/** 获取基本配置 */
import * as Mutation from "../store/mutation";
export default {
    data() {
        return {
            /** 大图路径 */
            bigImgInfo: {},
        };
    },
    created() {
        this.getBasicConfigApi();
    },
    methods: {
        // 获取大图  
        async getBasicConfigApi() {
            try {
                const res = await this.$get('/api/index/basicConfig');
                this.bigImgInfo = res.data.banner || {};
                this.$store.commit(Mutation.BASE_INFO, res.data)
            } catch (error) {
                console.error('Error fetching basic config:', error);
            }
        },
    },
};